<template>
  <div v-if="stock && show" class="wrapper">
    <v-icon
        class="icon"
        left
        :style="{color: stock.color}"
    >{{stock.icon}}</v-icon>
    <span :style="{color: stock.color}">{{stock.title}}</span>
  </div>
</template>

<script>
import {status} from '@/constants';

export default {
  name: 'OrderStockIndicator',
  computed: {
    stock: function () {
      if (typeof (this.order.countStock) === 'undefined' || this.order.countStock === null) return null;

      if (!this.order.countStock) {
        return status.stock.outOfStock
      } else if (this.order.countStock < this.order.count){
        const obj = status.stock.partialStock
        obj.title += `: ${this.order.countStock} из ${this.order.count}`
        return obj
      }
      return status.stock.inStock
    },
    show: function() {
      if(this.sourceStatuses?.statusesShowStock.includes(this.buyout.status)) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    order: {
      required: true,
      type: Object
    },
    sourceStatuses: {
      type: Object
    },
    buyout: {
      type: Object
    }
  }
}
</script>

<style scoped>
.wrapper {
  font-size: 12px;
}
.icon {
  height: 18px;
  width: 18px;
}
</style>